<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div>
    <p class="title">{{companyName}}</p>
    <p class="address_tel_fax">
      <span>地址：{{companyAddress}}</span>
      <span>Tel：010-84991047</span>
    </p>
    <p class="email_wx">
      <span>邮箱：yuezhenyu@qiniugroup.com</span>
      <span>微信号：yue10278</span>
    </p>
    <p class="copy"><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" rel="noopener noreferrer">{{icpNumber}}</a>  {{companyName}}</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      companyName: "风行网络科技有限公司", // Default fallback
      icpNumber: "京ICP备2025145680号-16 ", // Will store the ICP number
      companyAddress: "北京市朝阳区融新科技中心"
    };
  },
  mounted() {
    this.fetchICPInfo();
  },
  methods: {
    async fetchICPInfo() {
      try {
        const response = await fetch('/cloudlive/getICPInfo');
        if (response.ok) {
          const result = await response.json(); // Parse JSON response
          
          if (result.code === 0 && result.data) {
            this.icpNumber = result.data.companyIcp;
            this.companyName = result.data.companyName;
            this.companyAddress = result.data.companyAddress;
          } else {
            console.error('API returned error:', result);
          }
        } else {
          console.error('Failed to fetch ICP info:', response.status);
        }
      } catch (error) {
        console.error('Error fetching ICP info:', error);
      }
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.copy a {
  color: inherit;
  text-decoration: none;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue